import { Button, Modal, Form, Row, Col, Select, message } from "antd";
import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleUpdateUnit } from "../../../api/users";
import { handleFetchUnits } from "../../../api/units";


export default function UpdateUnit({ isVisible, setVisible, selected }: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const initials = {
    name: "",
  };

  const [filters, setFilters] = useState<any>({ ...initials });

  const params = `name=${filters?.name}`;

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 200,
    total: 0,
  });

  const {
    data: units,
  } = useQuery({
    queryKey: ["units", pagination.page, pagination.limit, params],
    queryFn: () =>
      handleFetchUnits({
        page: pagination.page,
        limit: pagination.limit,
        params,
      }),
  });

  const { mutate, isPending } = useMutation({
    mutationFn: handleUpdateUnit,
    onSuccess: () => {
      message.success("Updated Successfully");
      form.resetFields();
      setVisible(false);
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const unitOptions = units?.records?.map((item: any, index: number) => (
    <Select.Option value={item?._id} key={index}>{item?.name}</Select.Option>
  ))

  const onSubmit = async () => {
    const { businessUnitRef } = await form.getFieldsValue();
    const data = { businessUnitRef };
    await mutate({ _id: selected?._id, data });
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title="Update Business Unit"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="updateBUnit"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Update
        </Button>,
      ]}
    >
      <Form
        id="updateBUnit"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="font-bold my-2">
          {selected?.name}
        </div>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="businessUnitRef"
              label={"Business unit"}
              rules={[
                {
                  required: false,
                  message: "Please select business unit",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Business unit"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {unitOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
